import {IStateEvent} from './reducer';
import {ICommentSort, IComment} from '../../comment/type';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../common/util/redux';
import {
  IEventModuleMap,
  IEventTypeV4,
  IMissionActionName,
  IMissionParam,
  IModuleMapV4,
} from '../type';

export enum ActionType {
  SetValue = 'event.SetValue',
  SetPropertyValues = 'event.SetPropertyValues',
  SetEventModuleMap = 'event.SetEventModuleMap',
  SetEventModuleMapV4 = 'event.SetEventModuleMapV4',
  FetchEventModuleMap = 'event.FetchEventModuleMap',
  FetchEventComment = 'event.FetchEventComment',
  SetEventComments = 'event.SetEventComments',
  SetContentSubscribe = 'event.SetContentSubscribe',
  FetchContentSubscribe = 'event.FetchContentSubscribe',
  FetchPostEventComment = 'event.FetchPostEventComment',
  FetchEventCollect = 'event.FetchEventCollect',
  FetchQuizAnswer = 'event.FetchQuizAnswer',
  SetMissionComplete = 'event.SetMissionComplete',
  SetEventInitData = 'event.SetEventInitData',
}

export const actions = {
  ...createBasicActions<IStateEvent>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  setEventModuleMap: ({
    data,
    isExpired,
    showLoading = true,
    eventId,
    questCampaignId,
  }: {
    data?: IEventModuleMap;
    isExpired?: boolean;
    showLoading?: boolean;
    eventId?: number;
    questCampaignId?: number;
  }) =>
    createAction(ActionType.SetEventModuleMap, {
      data,
      isExpired,
      showLoading,
      eventId,
      questCampaignId,
    }),
  setEventModuleMapV4: (params: IModuleMapV4) =>
    createAction(ActionType.SetEventModuleMapV4, params),
  fetchEventModuleMap: (eventType: IEventTypeV4, eventId: number) =>
    createActionFetch(ActionType.FetchEventModuleMap, {
      payload: {eventType, eventId},
    }),
  fetchEventComment: (eventId: number, sort: ICommentSort) =>
    createActionFetch(ActionType.FetchEventComment, {
      payload: {eventId, sort},
      fetchKey: eventId,
    }),
  setEventComments: (comments: IComment[], sort: ICommentSort) =>
    createAction(ActionType.SetEventComments, {comments, sort}),
  setContentSubscribe: (isOn: boolean, index: number) =>
    createAction(ActionType.SetContentSubscribe, {isOn, index}),
  fetchContentSubscribe: ({
    id,
    isOn,
    index,
  }: {
    id: number;
    isOn: boolean;
    index: number;
  }) =>
    createActionFetch(ActionType.FetchContentSubscribe, {
      payload: {id, isOn, index},
      fetchKey: id,
    }),
  fetchPostEventComment: (eventId: number, content: string) =>
    createActionFetch(ActionType.FetchPostEventComment, {
      payload: {eventId, content},
    }),
  fetchEventCollect: (param: IMissionParam, index?: number) =>
    createActionFetch(ActionType.FetchEventCollect, {
      payload: {param, index},
      fetchKey: index,
    }),
  setMissionComplete: (actionName: IMissionActionName, index?: number) =>
    createAction(ActionType.SetMissionComplete, {actionName, index}),
  fetchQuizAnswer: (keyword: string) =>
    createActionFetch(ActionType.FetchQuizAnswer, {payload: {keyword}}),
  setEventInitData: (bgColor: string) =>
    createAction(ActionType.SetEventInitData, {bgColor}),
};
